import { Grid } from "@material-ui/core";
import React from "react";
import ReactLoading from "react-loading";

const Loading = () => {
  return (
    <Grid container direction="column" justify="center" alignItems="center">
      <Grid item>
        <ReactLoading
          type="bubbles"
          color="#333333"
          height={50}
          width={50}
        />
      </Grid>
    </Grid>
  );
}

export default Loading;